import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { ItemFieldTemplateFilters } from 'store/item-field-templates/itemFieldTemplate';

export const TEMPLATE_FORM_VALUES_MAP = {
    IRELAND: {
        IMPORT: ['H1', 'H7', 'I1'],
        EXPORT: ['B1', 'B2', 'B3', 'B4', 'C1', 'C2'],
        NCTS: ['D1', 'D2', 'D3', 'D4'],
    },
    UK: {
        IMPORT: ['H1', 'H2'],
        EXPORT: ['B1'],
        NCTS: ['D1', 'D2', 'D3', 'D4'],
    },
    // ICS2 goods-item templates are not supported yet, so EU is offered on the
    // declaration tab only.
    EU: {
        ENS: ['F11', 'F50'],
    },
} as Record<string, Record<string, string[]>>;

// Phase 1: item field templates exist for UK Export B1 only.
export const ITEM_FIELD_TEMPLATES_COUNTRY = 'uk';
export const ITEM_FIELD_TEMPLATES_INTERNAL_TYPE = 'EXPORT';
export const ITEM_FIELD_TEMPLATES_FORM_TYPE = 'B1';

// The list filters that select the templates of the dashboard
export const ITEM_FIELD_TEMPLATES_FILTERS: ItemFieldTemplateFilters = {
    declarationExternalEntity: DeclarationExternalEntity.CDS,
    declarationInternalType: DeclarationInternalType.EXPORT,
    declarationName: ITEM_FIELD_TEMPLATES_FORM_TYPE,
};
